export const USER_PERMISSION_GROUPS = [
  {
    id: "admin",
    label: "Admin",
    keys: ["isAdmin", "Permiso_Users"],
  },
  {
    id: "dashboard",
    label: "Dashboard",
    keys: [
      "Permiso_Dashboard",
      "Permiso_DashboardDesigns",
      "Permiso_RankingVenta",
      "Permiso_Organigrama",
      "Permiso_Novedades",
    ],
  },
  {
    id: "crm",
    label: "CRM",
    keys: [
      "Permiso_Clients",
      "Permiso_ClientsUpdate",
      "Permiso_ClientsAddContact",
      "Permiso_ClientsAddActivity",
      "Permiso_ClientsAddProject",
      "Permiso_Reuniones",
      "Permiso_Reuniones_VerTodas",
      "Permiso_KambanClientes",
      "Permiso_KambanProyectos",
      "Permiso_Task",
      "Permiso_ToDoListGlobal",
    ],
  },
  {
    id: "development",
    label: "Desarrollo",
    keys: [
      "Permiso_Designs",
      "Permiso_Samples",
      "Permiso_CreateSample",
      "Permiso_Estimates",
      "Permiso_AbrirEstimate",
      "Permiso_Articulos",
      "Permiso_PedidosA3",
      "Permiso_Colores",
      "Permiso_Materialoteca",
      "Permiso_Ferias",
      "Permiso_Suppliers",
      "Permiso_Factories",
    ],
  },
  {
    id: "tracking",
    label: "Critical Path / Tracking",
    keys: [
      "Permiso_CriticalPathUnido",
      "Permiso_CriticalPathGlobal",
      "Permisos_Expected_CP",
      "Permiso_AddNotes",
      "Permiso_SeeAllNotes",
      "Permiso_SamplesLocation",
      "Permiso_Maletash",
      "Permiso_Tesoros",
    ],
  },
  {
    id: "ai",
    label: "AI / Conocimiento",
    keys: [
      "Permiso_Nasdesign",
      "Permiso_PresentacionesAI",
      "Permiso_Skills",
      "Permiso_TareasAgentes",
      "Permiso_conocimiento",
      "Permiso_CrearMensajes",
    ],
  },
  {
    id: "finance",
    label: "Finanzas",
    keys: [
      "Permiso_PyG",
      "Permiso_CashFlow",
      "Permiso_Tpv",
      "Permiso_PedidosVenta",
      "Permiso_MargenesVenta",
      "Permiso_VentaTotal",
      "Permiso_Expenses",
      "Permiso_Vertodo_Expenses",
      "Permiso_ExpensesNew",
      "Permiso_Nominas",
      "Permiso_InsightsEjecutivos",
      "Permiso_InformesEC",
      "Permiso_Brands",
      "Permiso_CurrencyManager",
      "Permiso_Duties",
      "Permiso_Cbm",
    ],
  },
  {
    id: "nml",
    label: "NML",
    keys: [
      "Permiso_NMLFinanzas",
      "Permiso_NmlSuzhou",
      "Permiso_NmlTurkey",
      "Permiso_NmlGuangzhou",
      "Permiso_NmlSuzhouCliente",
    ],
  },
  {
    id: "user",
    label: "Usuario / RRHH",
    keys: [
      "Permiso_Booking",
      "Permiso_UserVisitCard",
      "Permiso_JobDescription",
      "Permiso_VisualizarJobs_Todos",
      "Permiso_SubirDocsUser",
      "Permiso_Fichaje",
      "Permiso_ControlHorario_RRHH",
      "Permiso_Emails",
      "Permiso_UniboxStats",
    ],
  },
];

export const USER_PERMISSION_KEYS = USER_PERMISSION_GROUPS.flatMap(
  (group) => group.keys,
);

export function sanitizePermissionsForSave(
  permissions = {},
  keys = USER_PERMISSION_KEYS,
) {
  return keys.reduce((acc, perm) => {
    acc[perm] = !!permissions[perm];
    return acc;
  }, {});
}

export function parseProveedoresPermitidosJson(text) {
  if (!String(text ?? "").trim()) {
    return { ok: true, value: null };
  }
  try {
    return { ok: true, value: JSON.parse(text) };
  } catch {
    return { ok: false, error: "JSON inválido" };
  }
}

export function permissionsHasAnyEnabled(permissions = {}) {
  return Object.values(permissions).some(Boolean);
}

export function mapUserToPermissionState(
  data = {},
  keys = USER_PERMISSION_KEYS,
) {
  const mapped = keys.reduce((acc, perm) => {
    acc[perm] = !!data[perm];
    return acc;
  }, {});
  if (Object.prototype.hasOwnProperty.call(mapped, "Permiso_NmlGuangzhou")) {
    mapped.Permiso_NmlGuangzhou = !!(
      mapped.Permiso_NmlGuangzhou || data.Permiso_NmlWangzhou
    );
  }
  return mapped;
}

export const USER_COUNTRY_META = {
  ES: { key: "ES", label: "España", flag: "🇪🇸", color: "#c62828" },
  CN: { key: "CN", label: "China", flag: "🇨🇳", color: "#d32f2f" },
  NML_CN: { key: "NML_CN", label: "NML China", flag: "🇨🇳", color: "#880e4f" },
  TR: { key: "TR", label: "Turquía", flag: "🇹🇷", color: "#e53935" },
  DK: { key: "DK", label: "Dinamarca", flag: "🇩🇰", color: "#c62828" },
  OTHER: { key: "OTHER", label: "Sin país", flag: "🌐", color: "#546e7a" },
};

const USER_COUNTRY_ORDER = ["ES", "CN", "NML_CN", "TR", "DK", "OTHER"];

const EMAIL_DOMAIN_COUNTRY = {
  "stagedesign.es": "ES",
  "ship-quik.com": "ES",
  "stageleather.com": "CN",
  "stagegroup.com.cn": "CN",
  "nomanslabel.dk": "DK",
  "nomanslabel.com": "TR",
};

const USERNAME_COUNTRY = {
  miguel: "ES",
  river: "ES",
  storm: "ES",
  elena: "NML_CN",
  amanda: "NML_CN",
};

const EMAIL_COUNTRY = {
  "elena-chen@nomanslabel.com": "NML_CN",
  "amanda-wang@nomanslabel.com": "NML_CN",
};

function userEmail(user) {
  const safeUser = user || {};
  return String(safeUser.email || safeUser.EMAIL || "")
    .trim()
    .toLowerCase();
}

function emailDomain(email = "") {
  const at = email.lastIndexOf("@");
  return at >= 0 ? email.slice(at + 1) : "";
}

export function resolveUserCountry(user) {
  // `null` is common before getUserById resolves; default params only cover undefined.
  const safeUser = user || {};
  const username = String(safeUser.username || "")
    .trim()
    .toLowerCase();
  if (USERNAME_COUNTRY[username]) return USERNAME_COUNTRY[username];

  const email = userEmail(safeUser);
  if (EMAIL_COUNTRY[email]) return EMAIL_COUNTRY[email];

  const domain = emailDomain(email);
  if (!domain) return "OTHER";
  if (EMAIL_DOMAIN_COUNTRY[domain]) return EMAIL_DOMAIN_COUNTRY[domain];
  if (domain.endsWith(".com.cn") || domain.endsWith(".cn")) return "CN";
  if (domain.endsWith(".es")) return "ES";
  if (domain.endsWith(".dk")) return "DK";
  return "OTHER";
}

export function canUserAccessProductTree(user) {
  const safeUser = user || {};
  const country = resolveUserCountry(safeUser);
  const username = String(safeUser.username || "")
    .trim()
    .toLowerCase();
  const email = userEmail(safeUser);
  const isLars = username === "lars" || email === "lars@nomanslabel.dk";

  return Boolean(
    (safeUser.isAdmin || safeUser.Permiso_Designs) &&
    country !== "CN" &&
    country !== "NML_CN" &&
    country !== "TR" &&
    !isLars,
  );
}

export function getUserCountryMeta(user = {}) {
  return USER_COUNTRY_META[resolveUserCountry(user)] || USER_COUNTRY_META.OTHER;
}

export function groupUsersByCountry(users = []) {
  const buckets = new Map();
  for (const user of users) {
    const key = resolveUserCountry(user);
    if (!buckets.has(key)) buckets.set(key, []);
    buckets.get(key).push(user);
  }

  return USER_COUNTRY_ORDER.filter((key) => buckets.has(key)).map((key) => ({
    ...USER_COUNTRY_META[key],
    users: buckets.get(key),
  }));
}
